import DateUtilsService from 'external-services/date-utils-service';
import PouchLoadService from 'external-services/pouch-load-service/index';

const NS = 'NotesService'; // jshint ignore:line

export interface INoteSaveData {
  _id?: string;
  _rev?: string;
  type?: string;
  note: string;
}

export interface INoteDocData {
  id: string;
  key: string;
  doc: INoteSaveData;
  value: {
    rev: string;
  };
}

export interface INoteGetData {
  offset?: number;
  rows?: INoteDocData[];
  length: number;
}
export const PrefixNote = 'note_';

class NotesService {
  public getNote(date: Date): Promise<any> {
    // Use allDocs to avoid the 404 console error for missing note
    return new Promise((resolve: any, reject: any) => {
      const database: any = PouchLoadService.selectDatabase(date);
      database
        .allDocs({
          include_docs: true,
          attachments: true,
          startkey: this.getNoteId(date),
          endkey: this.getNoteId(date),
        })
        .then((data: INoteGetData) => {
          if (data.rows.length) {
            resolve(data.rows[0].doc);
          } else {
            reject();
          }
        })
        .catch((e: any) => reject(e));
    });
  }

  public saveNote(date: Date, note: INoteSaveData): Promise<any> {
    note._id = note._id || this.getNoteId(date);
    note.type = 'note';
    return Promise.resolve(PouchLoadService.getDbLocal().put(note));
  }

  private getNoteId(date: Date): string {
    return PrefixNote + DateUtilsService.dateToIdStr(date);
  }
}

const instance = new NotesService();
export default instance as NotesService;
